import { render, staticRenderFns } from "./academic-research-publications.vue?vue&type=template&id=3840fdcb&"
import script from "./academic-research-publications.vue?vue&type=script&lang=ts&"
export * from "./academic-research-publications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonAcfHero: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/acf/CommonAcfHero.vue').default,ResourcesSection: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/resources/ResourcesSection.vue').default})
